module.exports = __webpack_public_path__ + "img/syndic.04923c50.svg";